












































































































































































































































































































































import {
  Department,
  DepartmentEmployeeAssignment,
  Employee,
  ListMessageResponse,
  SmsMessage,
} from "@/api";
import { selfData } from "@/common/role_utils";
import { VForm } from "@/common/vuetify_types";
import { maxFileSize, requiredString, maxLen } from "@/tool/validation";
import _ from "lodash";
import { Component, Vue, Ref } from "vue-property-decorator";
import shifts from "@/common/shift_type";
import moment from "moment";
import loading from "@/components/loader/loading.vue";

type SmsMessageWithShow = {
  message: string;
  direction: "inbound" | "outbound-api" | "outbound-call" | "outbound-reply";
  from: string;
  to: string[];
  dateSent: string;
  status:
    | "queued"
    | "sending"
    | "sent"
    | "failed"
    | "delivered"
    | "undelivered"
    | "receiving"
    | "received"
    | "accepted"
    | "scheduled"
    | "canceled"
    | "read";
  uri: string;
  media?: Record<string, string> | null | undefined;
  showAll: boolean;
};

@Component({
  components: {
    loading,
  },
})
export default class MessageLayout extends Vue {
  @Ref("form") form!: VForm;
  stateShifts = shifts();
  shifts = [{ id: 3, name: "All Shift" }, ...this.stateShifts];
  shift = 3;
  message: string | undefined = "";
  search = "";
  showAll = false;
  sending = false;
  fetchingMessage = false;
  fetchMoreHistory = false;
  fetchingMoreHistory = false;
  employeeId: number[] = [];
  departmentId = 0;
  counter = 0;
  to: number[] = [];
  from = "+15203143777";
  companyId: number = selfData().companyId;
  res: { errors: string[]; total: number } | null = null;
  url: string | ArrayBuffer | null | undefined = "";
  document: File | null = null;
  documentName = "";
  fileErr = "";
  textRules = [requiredString, (v: string) => maxLen(v, 1600)];
  fileRules = [(v: File) => maxFileSize(v, 5)];
  selectAllValue = false;
  title = 0;
  messageHistory: SmsMessageWithShow[] = [];
  pageToken = "";

  async created() {
    this.fetchingMessage = true;
    const emp = this.$store.dispatch("directory/loadAllEmployees", true);
    const his = this.$store.dispatch("sms/getSMSHistory", {});

    await Promise.all([emp, his]);
    this.fetchingMessage = false;
  }

  get messages(): string[] {
    return this.$store.getters["message/messages"];
  }

  get employeeIds() {
    return this.showAll ? this.employeeId : this.employeeId.slice(0, 3);
  }

  get employees(): { alphabet: string; records: Employee[] }[] {
    const search = !this.search ? "" : this.search;
    const employees = this.$store.state.directory.employees;
    const list = _.reduce(
      _.orderBy(
        _.filter(
          _.filter(
            _.filter(employees ?? [], (e: Employee) => {
              if (this.shift < 3 && this.shift >= 0) {
                return this.shift == e.shift;
              } else {
                return true;
              }
            }),
            (emp: Employee) => {
              if (this.departmentId != 0) {
                if (this.title != 0) {
                  return emp.titleId == this.title;
                }
                return emp.primaryDepartmentId == this.departmentId;
              } else {
                return true;
              }
            },
          ),
          (employee: Employee) =>
            _.includes(
              `${employee.firstName?.toLowerCase()} ${employee.lastName?.toLowerCase()}`,
              search.toLowerCase(),
            ),
        ),
        [
          (employee: Employee) =>
            `${employee.firstName?.toLowerCase()} ${employee.lastName?.toLowerCase()}`,
        ],
        ["asc"],
      ),
      (acc: { alphabet: string; records: Employee[] }[], cur) => {
        const alphabet = cur.firstName[0].toUpperCase();
        if (!acc[alphabet]) acc[alphabet] = { alphabet, records: [cur] };
        else acc[alphabet].records.push(cur);
        return acc;
      },
      [],
    );
    return Object.values(list);
  }

  get smsHistory(): SmsMessageWithShow[] {
    const res =
      (this.$store.getters["sms/smsHistory"] as ListMessageResponse) || [];
    const list = res?.messages || [];
    this.messageHistory = [];
    this.pageToken = res?.nextPageToken || "";
    this.fetchMoreHistory = res?.nextPageToken ? true : false;
    list.forEach((sms: SmsMessage) => {
      this.messageHistory.push({
        message: sms.message,
        direction: sms.direction,
        from: sms.from,
        to: sms.to,
        dateSent: sms.dateSent,
        status: sms.status,
        uri: sms.uri,
        media: sms.media,
        showAll: false,
      });
    });
    return this.messageHistory;
  }

  setMessageHistoryShowALL(index: number, show: boolean) {
    this.messageHistory[index].showAll = show;
  }

  getEmployeeName(id: number): string {
    const employees = this.$store.state.directory.employees;
    const employee = _.find(
      employees,
      (employee: Employee) => employee.id == id,
    );
    return `${employee.firstName} ${employee.lastName}`;
  }

  getEmployeeByPhone(phone: string): string {
    let trimPhone = phone;
    if (phone.startsWith("+1")) {
      trimPhone = phone.substring(2);
    } else if (phone.startsWith("1")) {
      trimPhone = phone.substring(1);
    }
    const employees = this.$store.state.directory.employees;
    const employee = _.find(
      employees,
      (employee: Employee) => employee.phone == trimPhone,
    );
    return `${employee?.firstName} ${employee?.lastName}` || "unknown";
  }

  formatMessageDate(dateStr: string): string {
    const date = moment(dateStr);
    return date.format("MM/DD/YYYY hh:mm A");
  }

  primaryDepartment(
    departments: DepartmentEmployeeAssignment[],
    primaryDepartment: number,
  ) {
    const primary = departments.find(
      item => item.departmentId === primaryDepartment,
    );
    return primary?.departmentName;
  }

  selectEmployee(employeeId: number) {
    if (this.employeeId.includes(employeeId)) {
      const index = this.employeeId.indexOf(employeeId);
      this.employeeId.splice(index, 1);
    } else {
      this.employeeId.push(employeeId);
    }
  }

  clearPayload() {
    this.message = undefined;
    this.to = [];
    this.employeeId = [];
    this.document = null;
    this.form.reset();
    this.form.resetValidation();
  }

  async submit() {
    this.res = null;
    this.to = this.employeeId;
    this.sending = true;
    const payload = {
      message: this.message,
      to: this.to,
      from: this.from,
      file: this.document || undefined,
      companyId: selfData().companyId,
    };

    const res = await this.$store.dispatch("sms/smsWithMedia", payload);
    this.res = res;
    this.clearPayload();
    this.sending = false;
  }

  get departments(): Department[] {
    const departments = this.$store.state.company.departments;
    if (departments) {
      return [
        { id: 0, name: "All Department", companyId: 0, isArchived: false },
        ...departments,
      ];
    } else {
      return [];
    }
  }

  onChangeFile(file: File) {
    this.fileErr = "";
    this.counter++;
    if (file) {
      const reader = new FileReader();

      reader.onload = (event: ProgressEvent<FileReader>) => {
        if (event) {
          this.documentName = file.name;
          this.url = URL.createObjectURL(file);
        }
      };
      reader.readAsArrayBuffer(file);
      this.document = file;
    }
  }

  selectAll() {
    this.employeeId = [];
    if (this.selectAllValue) {
      _.forEach(this.employees, emp => {
        _.forEach(emp.records, e => this.employeeId.push(e.id));
      });
    }
  }

  async getDepartmentTitle() {
    this.title = 0;
    await this.$store.dispatch("departmentAdmin/getTitle", this.departmentId);
  }

  get titleList() {
    const list = this.$store.getters["departmentAdmin/departmentTitle"];
    if (list) {
      return list;
    } else {
      return [];
    }
  }

  async onHistoryIntersect() {
    // alert("intersected");
    // return;
    if (
      this.fetchingMoreHistory ||
      this.fetchingMessage ||
      !this.fetchMoreHistory
    )
      return;

    this.fetchingMoreHistory = true;

    await this.$store.dispatch("sms/getSMSHistory", {
      pageSize: 10,
      pageToken: this.pageToken,
    });

    this.fetchingMoreHistory = false;
  }
}
